import React from 'react'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import { Error404Desktop } from './Error404Desktop';
import { Error404Mobile } from './Error404Mobile';


export const Error404 = () => {

    return (
        <>{isMobile ? <Error404Mobile /> : <Error404Desktop />}</>
    )
}
